import { memo, useState } from 'react';
import dayjs from 'dayjs';

import theme from '@styles/theme';
import { HeaderType } from '@utils/types';
import { Pet } from '@graphql/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';
import CoOwnershipListModal from '@components/feature/Member/Status/Detail/CoOwnershipListModal';

type PetInfoTableRowType = {
    header: HeaderType[];
    data: Pet;
};

const PetInfoTableRow = ({ header = [], data }: PetInfoTableRowType) => {
    const [openModal, setOpenModal] = useState(false);
    return (
        <TableRow $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.createdAt
                    ? dayjs(data.createdAt).format('YYYY-MM-DD')
                    : '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.petNickName || '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.name || '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {data?.birth || '-'}
            </TableCell>
            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {data?.regNum || '-'}
            </TableCell>
            <TableCell $minWidth={header[5].minWidth} $width={header[5].width}>
                {data?.qrNum || '-'}
            </TableCell>
            <TableCell
                onClick={() => setOpenModal(true)}
                $minWidth={header[6].minWidth}
                $width={header[6].width}
                $cursor
                $fontColor={theme.colors.deepGrayFontColor}
            >
                공유자 보기
            </TableCell>
            {openModal && (
                <CoOwnershipListModal
                    isOpen={openModal}
                    setIsOpen={setOpenModal}
                    petId={data?.petId as number}
                />
            )}
        </TableRow>
    );
};

export default memo(PetInfoTableRow);
